import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import veterinarianListAction from './veterinarianList.action.json' with { type: 'json' }
import { veterinarianListItemObject } from '../veterinarianObject'

export const veterinarianExpression = expression(veterinarianListItemObject.shape)

const veterinarianListDefinition = defineAction({
  ...veterinarianListAction,

  input: z.object({
    filter: veterinarianExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      code: 'Codigo',
      fullName: 'Nome',
      cpf: 'CPF',
      citizenId: 'Cidadao',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeInactivated: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(veterinarianListItemObject),
    count: z.number(),
  }),
})

export default veterinarianListDefinition
